import * as React from 'react';
import Button from './common/button/Button';
import MonacoEditor from './MainControl/MonacoEditor/MonacoEditor';

interface IProps {
    closeCB?: () => void;
}

const ConsoleServer = (props: IProps) => {
    const [consoleserver, setConsoleserver] = React.useState<string>('');
    const editorRef = React.useRef<any>(null);

    const updateconsoleserver = async function () {
        const res = await fetch(window.hostdata + '/ConsoleInfo/Get');
        const text = await res.text();
        setConsoleserver(text);
        if (!editorRef?.current?._focusTracker.hasFocus())
            editorRef.current?.revealLine(editorRef.current?.getModel().getLineCount());
    };

    React.useEffect(() => {
        let interval = setInterval(() => {
            updateconsoleserver();
        }, 3000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    const ClearConsoleServer = function () {
        fetch(window.hostdata + '/ConsoleInfo/Clear', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        setConsoleserver('');
    };

    const handleEditorDidMount = function (editor: any, monaco: any) {
        editorRef.current = editor;
        setTimeout(updateconsoleserver, 500);
    };

    return (
        <React.Fragment>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    minWidth: '800px',
                    top: 0,
                    left: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                <div
                    style={{
                        background: '#fff',
                        padding: '1em',
                        width: '70em',
                        height: '40em',
                        boxShadow: 'rgb(0 0 0 / 5%) 4px 4px 4px'
                    }}
                    onClick={(e) => e.stopPropagation()}>
                    <div style={{ display: 'flex', height: 'calc(100% - 3em)' }}>
                        <MonacoEditor
                            value={consoleserver}
                            language="shell"
                            callbackOnDidmount={handleEditorDidMount}
                        />
                    </div>
                    <div style={{ display: 'flex', position: 'relative', zIndex: '1', marginTop: '5px' }}>
                        <Button
                            text={'Очистить'}
                            onClick={() => {
                                ClearConsoleServer();
                            }}
                        />
                        <Button
                            text={'Отмена'}
                            onClick={() => {
                                props.closeCB && props.closeCB();
                            }}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ConsoleServer;
